"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = void 0;
var Head_1 = require("./Head");
Object.defineProperty(exports, "Head", { enumerable: true, get: function () { return __importDefault(Head_1).default; } });
